import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Fade from '@mui/material/Fade';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import DashboardStyles from '../../../../assets/jss/Components/DashboardStyles';

export interface ProgressSnackbarProps {
    processInProgress: boolean;
    title: string;
    tooltipText: string;
}

// ui reflection of file view
export const ProgressSnackbar: React.FC<ProgressSnackbarProps> = ({
    processInProgress,
    title,
    tooltipText,
}) => {
    const [inProgress, setInProgress] = useState(false);
    const { classes } = DashboardStyles();

    useEffect(() => {
        if (processInProgress) {
            setInProgress(true);
        } else {
            handleClose();
        }
        return () => {
            handleClose();
        };
    }, [processInProgress]);

    const handleClose = () => {
        setInProgress(false);
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                open={inProgress}
                // open={true}
                // @ts-ignore
                // onClose={handleClose}
                TransitionComponent={Fade}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    elevation: 0,
                    classes: {
                        root: classes.snackbarOverwrite,
                    },
                }}
                classes={{
                    root: classes.anchorOverwrite,
                }}
                message={
                    <Tooltip title={tooltipText}>
                        <Grid container alignItems={'center'}>
                            <Grid item xs={12}>
                                <LinearProgress />
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant={'caption'}
                                    color={'primary'}
                                >
                                    {title}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Tooltip>
                }
            />
        </div>
    );
};

export default ProgressSnackbar;
